import { FiInfo } from 'react-icons/fi';

export default function AmountBreakdown({ amount, processingFee, totalAmount }) {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  };

  return (
    <div className="mb-6 p-4 bg-primary-50 dark:bg-primary-900/20 rounded-lg space-y-3">
      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-600 dark:text-gray-300">Amount:</span>
        <span className="font-medium text-gray-900 dark:text-white">
          {formatCurrency(amount)}
        </span>
      </div>
      
      <div className="flex justify-between items-center text-sm">
        <div className="flex items-center gap-1">
          <span className="text-gray-600 dark:text-gray-300">Processing Fee:</span>
          <FiInfo className="h-4 w-4 text-gray-400" title="Card processing fee" />
        </div>
        <span className="font-medium text-gray-900 dark:text-white">
          {formatCurrency(processingFee)}
        </span>
      </div>

      <div className="pt-2 border-t border-primary-100 dark:border-primary-800">
        <div className="flex justify-between items-center">
          <span className="font-medium text-gray-700 dark:text-gray-200">Total:</span>
          <span className="font-bold text-gray-900 dark:text-white">
            {formatCurrency(totalAmount)}
          </span>
        </div>
      </div>
    </div>
  );
}